exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rt-picture[data-v-5d581d62]{display:inline-block;padding:0;margin:0;max-width:100%;height:auto;-o-object-fit:contain;object-fit:contain}", ""]);

